import AuthService from "../login/auth.service";
import { dimo } from "../../components/generico/utils/UrlAPI";
import axios from "axios";

class ComprobantePagoQRService {
  async listaComprobantePagoQR(mes) {
    var data = JSON.stringify({ mes: mes });
    var config = {
      method: "post",
      url: dimo + "qr/listaComprobanteQR",
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }

}
export default new ComprobantePagoQRService();
